export class FileInput {

    private storedFiles:File[]=[];

    constructor (protected container:JQuery) {
        if (this.container.closest('.form-type-bigfile').length) return;

        container.on('click',(ev)=>this.onClick(ev));
        container.on('change',(ev)=>this.onChange(ev));
        container.on('keydown',(ev)=>this.onKeyPress(ev));

        this.container.on('dragover dragenter dragleave',(ev)=>{this.dragHandler(ev)});
        this.container.on('drop',(ev)=>{this.dropHandler(ev)});

        this.syncWidget();
    }

    protected humanFileSize(size:number) {
        let i = size == 0 ? 0 : Math.floor(Math.log(size) / Math.log(1024));
        return +((size / Math.pow(1024, i)).toFixed(2)) * 1 + ' ' + ['B', 'KB', 'MB', 'GB', 'TB'][i];
    }

    protected onKeyPress(ev:JQuery.TriggeredEvent) {
        if (ev.key==' ' || ev.key=='Enter') {
            ev.preventDefault();
            this.click();
        }
        if (ev.key=='Backspace' || ev.key=='Delete') {
            this.clear();
        }
    }

    public click() {
        this.container.find('input').click();
    }

    public clear() {
        let input=this.container.find('input');
        input.val('');
        this.syncWidget();
    }

    protected syncWidget() {
        let input=this.container.find('input');
        let list=this.container.find('.list')
        list.empty();

        let files=input[0].files??new FileList();

        if (!files.length) {

            if (!list.length) {
                this.container.find('.preview').attr("src","//:0");
                this.container.find('.icon').attr('data-type','');
                this.container.find('.name').text('');
                this.container.find('.size').text('');
            }

            return;
        }

        let template=$(this.container.find('.item').prop('content'));

        for (const [idx, file] of Object.entries(files)) {
            let item=$('<span class="item">');
            item.append(template.clone());
            item.data('index',idx);

            let preview=item.find('.preview');
            if (preview.length) {
                let fileUrl=URL.createObjectURL(file);
                preview.attr("src",fileUrl);
            }

            let fileNameParts=file.name.split('.');
            let fileExt=fileNameParts[fileNameParts.length-1]??'';
            item.find('.icon').attr('data-type',fileExt.toLowerCase());
            item.find('.name').text(file.name);
            item.find('.size').text(this.humanFileSize(file.size));

            list.append(item);
        }
    }

    protected saveCurrentFiles() {
        let input=this.container.find('input');
        this.storedFiles=Array.from(input[0].files??[]);
    }

    protected mergeNewFiles() {
        let input=this.container.find('input');
        const dt=new DataTransfer();
        for (const file of this.storedFiles || []) dt.items.add(file);
        for (const file of input[0].files??[]) dt.items.add(file);
        input[0].files=dt.files;
        this.saveCurrentFiles();
    }

    protected onChange(ev:JQuery.TriggeredEvent) {
        if (ev.target.tagName!='INPUT') return;
        this.mergeNewFiles();
        this.syncWidget();
    }

    protected removeIndex(indexToRemove:number) {
        let input=this.container.find('input');
        const dt = new DataTransfer();

        Array.from(input[0].files??[]).forEach((file, index) => {
            if (index !== indexToRemove) {
              dt.items.add(file);
            }
        });

        input[0].files = dt.files;
        this.saveCurrentFiles();
    }

    protected onClick(ev:JQuery.TriggeredEvent) {
        if ($(ev.target).closest('.remove').length) {
            let idx=Number($(ev.target).closest('.item').data('index'));
            this.removeIndex(idx);
            this.syncWidget();
            ev.preventDefault();
            return;
        }

        if (ev.target.tagName=='INPUT') return;
        this.click();
        ev.preventDefault();
    }

    protected dragHandler(ev:JQuery.TriggeredEvent) {
        ev.preventDefault();
        if (ev.type == 'dragenter' || ev.type == 'dragover') {
            this.container.addClass('drag-mode');
        } else if (ev.type == 'dragleave') {
            this.container.removeClass('drag-mode');
        }
    }

    protected dropHandler(ev:JQuery.DropEvent) {
        if (!ev.originalEvent) return;
        ev.preventDefault();
        const files = ev.originalEvent.dataTransfer?.files;
        if (!files?.length) return;
        let input=this.container.find('input');
        input[0].files=files;
        this.mergeNewFiles();
        this.container.removeClass('drag-mode');
        this.syncWidget();
    }

}

export {};